import React from 'react';
import './refundpolicy.css'; 

function Refund1() {
  return (
    <div className="wholecontent">
      <div className="header-container">
        <h1 className="privacy">Refund Policy</h1>
      </div>
      <div className="privacycontent">
        
        <h6>1. Eligibility for Refunds:</h6>
        <h6>• Clients are eligible to request a refund for services purchased from <span className="span">Brand Marketing Hub</span> within 60 days from the date of purchase.</h6>
        <h6>• After the initial 60-day period, clients may still request a refund at any time.</h6>
        <h6>2. Refund Process:</h6>
        <h6>• To initiate a refund, please contact our customer support team at <span className="span">info@bmh.com</span> with your order details and the reason for the refund request.</h6>
        <h6>• Once we receive your request, we will review it and notify you of the status of your refund within 7 business days.</h6>
        <h6>3. Refund Approval:</h6>
        <h6>• If your refund is approved, we will initiate a refund to your original method of payment.</h6>
        <h6>• You will receive the credit within a certain number of days, depending on your card issuer’s policies.</h6>
        <h6>4. Non-Refundable Services:</h6>
        <h6>• Custom or personalized services that have been substantially started or completed.</h6>
        <h6>• Any services explicitly stated as non-refundable at the time of purchase.</h6>
         
      </div>
    </div>
  );
}

export default Refund1;
